// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/echo_bot_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { protoMetadata as protoMetadata1, Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "echobot";

export enum RecorderStatus {
  NOT_RECORDING = 0,
  RECORDING = 1,
  ERROR = 2,
  COMPLETE = 3,
  INITIALIZING = 4,
  UNRECOGNIZED = -1,
}

export function recorderStatusFromJSON(object: any): RecorderStatus {
  switch (object) {
    case 0:
    case "NOT_RECORDING":
      return RecorderStatus.NOT_RECORDING;
    case 1:
    case "RECORDING":
      return RecorderStatus.RECORDING;
    case 2:
    case "ERROR":
      return RecorderStatus.ERROR;
    case 3:
    case "COMPLETE":
      return RecorderStatus.COMPLETE;
    case 4:
    case "INITIALIZING":
      return RecorderStatus.INITIALIZING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RecorderStatus.UNRECOGNIZED;
  }
}

export function recorderStatusToJSON(object: RecorderStatus): string {
  switch (object) {
    case RecorderStatus.NOT_RECORDING:
      return "NOT_RECORDING";
    case RecorderStatus.RECORDING:
      return "RECORDING";
    case RecorderStatus.ERROR:
      return "ERROR";
    case RecorderStatus.COMPLETE:
      return "COMPLETE";
    case RecorderStatus.INITIALIZING:
      return "INITIALIZING";
    case RecorderStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RecordingMode {
  RECORDING_MODE_STANDARD = 0,
  RECORDING_MODE_DEMONSTRATION = 1,
  UNRECOGNIZED = -1,
}

export function recordingModeFromJSON(object: any): RecordingMode {
  switch (object) {
    case 0:
    case "RECORDING_MODE_STANDARD":
      return RecordingMode.RECORDING_MODE_STANDARD;
    case 1:
    case "RECORDING_MODE_DEMONSTRATION":
      return RecordingMode.RECORDING_MODE_DEMONSTRATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RecordingMode.UNRECOGNIZED;
  }
}

export function recordingModeToJSON(object: RecordingMode): string {
  switch (object) {
    case RecordingMode.RECORDING_MODE_STANDARD:
      return "RECORDING_MODE_STANDARD";
    case RecordingMode.RECORDING_MODE_DEMONSTRATION:
      return "RECORDING_MODE_DEMONSTRATION";
    case RecordingMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Empty {
}

export interface SensorConfig {
  id: string;
  equipmentName: string;
  equipmentKey: string;
  sensorType: string;
  dataType: string;
  filename: string;
  isSecondary: boolean;
  /** JSON string */
  metadata: string;
}

export interface RecorderState {
  config: RecorderConfig | undefined;
  startTime: Date | undefined;
  recordingTime?: number | undefined;
  status: RecorderStatus;
  errors: string[];
  /**
   * .insv handheld-upload metrics (in-memory, reset on echo-bot restart):
   * count uploaded since start, and count still pending on disk. `optional`
   * so callers can tell "echo-bot's RPC handler threw before computing these"
   * (absent) apart from "computed and genuinely zero" — a recorder-level
   * error (status=ERROR from a bad recording) still computes these
   * independently, so status alone can't be used as a presence proxy.
   */
  insvUploadedCount?: number | undefined;
  insvBacklogCount?:
    | number
    | undefined;
  /**
   * Recent .insv import outcomes (most-recent-last), so the upload modal can
   * show per-file Uploaded / Duplicate / Failed instead of only a counter.
   * In-memory, bounded, reset on echo-bot restart.
   */
  recentImports: InsvUploadStatus[];
}

export interface UploadItem {
  recordingId: string;
  progress: number;
  error?: string | undefined;
}

export interface UploadState {
  uploads: UploadItem[];
}

/**
 * Per-file status of a handheld .insv upload, keyed by the inbox filename so
 * the upload modal can correlate the file it sent with what echo-bot did.
 * status is one of: processing | uploaded | duplicate | failed.
 */
export interface InsvUploadStatus {
  filename: string;
  status: string;
  /**
   * Human-readable reason, set only for terminal failures whose cause the
   * operator can act on (e.g. "no calibration for IAFNA2511FX9U4"). The UI
   * appends it to the status label; absent means "no extra detail", not
   * "unknown". Kept as free text rather than new `status` values so the
   * frontend's processing|uploaded|duplicate|failed bucketing stays exact.
   */
  detail?: string | undefined;
}

/** Standard Bots quaternion pose (x,y,z position + i,j,k,w orientation). */
export interface ReferenceFramePose {
  x: number;
  y: number;
  z: number;
  i: number;
  j: number;
  k: number;
  w: number;
}

/**
 * Optional "follow reference" anchor for a demonstration recording: the
 * reference's world pose at record time, plus the tcpOption it was saved in
 * (used by sphere-trim to choose wrist vs gripper-tip distance).
 */
export interface ReferenceFrame {
  refWorldPose: ReferenceFramePose | undefined;
  refTcpOption?: string | undefined;
}

/**
 * Equipment bound to a hardware key. For dual-lens cameras (Insta360) the
 * optional feed selects which lens the recording captures.
 */
export interface EquipmentAssignment {
  /** Equipment ID from bot(s). */
  equipmentId: string;
  /**
   * Lens selection for dual-lens cameras: "front" | "back". Unset for
   * single-lens devices; unrecognized values are ignored with a warning.
   */
  feed?: string | undefined;
}

export interface RecorderConfig {
  userId?: string | undefined;
  taskId?: string | undefined;
  isSecondary?: boolean | undefined;
  bots: string[];
  sensors: SensorConfig[];
  equipmentKeyAssignments: { [key: string]: EquipmentAssignment };
  tags: string[];
  recordingMode?: RecordingMode | undefined;
  referenceFrame?: ReferenceFrame | undefined;
}

export interface RecorderConfig_EquipmentKeyAssignmentsEntry {
  key: string;
  value: EquipmentAssignment | undefined;
}

export interface ConfigureRecordingRequest {
  config: RecorderConfig | undefined;
}

export interface ToggleBotPayload {
  botId: string;
  isEnabled: boolean;
}

export interface StartRecordingRequest {
  startTime: Date | undefined;
  equipmentKeyAssignments: { [key: string]: EquipmentAssignment };
}

export interface StartRecordingRequest_EquipmentKeyAssignmentsEntry {
  key: string;
  value: EquipmentAssignment | undefined;
}

export interface StepDetailsEntry {
  stepId: string;
  stepKind: string;
  /** we will always fill, but if it is 0 and not optional - proto omits it */
  startOffsetSec?: number | undefined;
  endOffsetSec?:
    | number
    | undefined;
  /** Time spent in step excluding substeps */
  selfTimeSec?:
    | number
    | undefined;
  /** IDs of parent steps in the hierarchy */
  parentStepIds: string[];
  /** JSON stringified step arguments/configuration */
  stepArgs?:
    | string
    | undefined;
  /** JSON stringified step output variables */
  stepVariables?: string | undefined;
}

export interface StepDetails {
  entries: StepDetailsEntry[];
}

export interface StopRecordingRequest {
  delete: boolean;
  tags: string[];
  stepDetails?: StepDetails | undefined;
}

export interface StopRecordingResponse {
  startTimestamp: Date | undefined;
  endTimestamp: Date | undefined;
  status: RecorderStatus;
}

export interface SaveRecordingRequest {
  recordingId?: string | undefined;
  startTimestamp: Date | undefined;
  endTimestamp: Date | undefined;
  wait?: boolean | undefined;
}

export interface SaveRecordingResponse {
  uploadId: string;
  error?: string | undefined;
}

export interface EchoBotResponse {
  success: boolean;
  errors: string[];
}

export interface AddTagRequest {
  tags: string[];
}

function createBaseEmpty(): Empty {
  return {};
}

export const Empty: MessageFns<Empty> = {
  encode(_: Empty, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Empty {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmpty();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Empty {
    return {};
  },

  toJSON(_: Empty): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Empty>, I>>(base?: I): Empty {
    return Empty.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Empty>, I>>(_: I): Empty {
    const message = createBaseEmpty();
    return message;
  },
};

function createBaseSensorConfig(): SensorConfig {
  return {
    id: "",
    equipmentName: "",
    equipmentKey: "",
    sensorType: "",
    dataType: "",
    filename: "",
    isSecondary: false,
    metadata: "",
  };
}

export const SensorConfig: MessageFns<SensorConfig> = {
  encode(message: SensorConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.equipmentName !== "") {
      writer.uint32(18).string(message.equipmentName);
    }
    if (message.equipmentKey !== "") {
      writer.uint32(26).string(message.equipmentKey);
    }
    if (message.sensorType !== "") {
      writer.uint32(34).string(message.sensorType);
    }
    if (message.dataType !== "") {
      writer.uint32(42).string(message.dataType);
    }
    if (message.filename !== "") {
      writer.uint32(50).string(message.filename);
    }
    if (message.isSecondary !== false) {
      writer.uint32(56).bool(message.isSecondary);
    }
    if (message.metadata !== "") {
      writer.uint32(66).string(message.metadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SensorConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSensorConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.equipmentName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.equipmentKey = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sensorType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.dataType = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isSecondary = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.metadata = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SensorConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      equipmentName: isSet(object.equipmentName) ? globalThis.String(object.equipmentName) : "",
      equipmentKey: isSet(object.equipmentKey) ? globalThis.String(object.equipmentKey) : "",
      sensorType: isSet(object.sensorType) ? globalThis.String(object.sensorType) : "",
      dataType: isSet(object.dataType) ? globalThis.String(object.dataType) : "",
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
      isSecondary: isSet(object.isSecondary) ? globalThis.Boolean(object.isSecondary) : false,
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : "",
    };
  },

  toJSON(message: SensorConfig): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.equipmentName !== "") {
      obj.equipmentName = message.equipmentName;
    }
    if (message.equipmentKey !== "") {
      obj.equipmentKey = message.equipmentKey;
    }
    if (message.sensorType !== "") {
      obj.sensorType = message.sensorType;
    }
    if (message.dataType !== "") {
      obj.dataType = message.dataType;
    }
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    if (message.isSecondary !== false) {
      obj.isSecondary = message.isSecondary;
    }
    if (message.metadata !== "") {
      obj.metadata = message.metadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SensorConfig>, I>>(base?: I): SensorConfig {
    return SensorConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SensorConfig>, I>>(object: I): SensorConfig {
    const message = createBaseSensorConfig();
    message.id = object.id ?? "";
    message.equipmentName = object.equipmentName ?? "";
    message.equipmentKey = object.equipmentKey ?? "";
    message.sensorType = object.sensorType ?? "";
    message.dataType = object.dataType ?? "";
    message.filename = object.filename ?? "";
    message.isSecondary = object.isSecondary ?? false;
    message.metadata = object.metadata ?? "";
    return message;
  },
};

function createBaseRecorderState(): RecorderState {
  return {
    config: undefined,
    startTime: undefined,
    recordingTime: undefined,
    status: 0,
    errors: [],
    insvUploadedCount: undefined,
    insvBacklogCount: undefined,
    recentImports: [],
  };
}

export const RecorderState: MessageFns<RecorderState> = {
  encode(message: RecorderState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      RecorderConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(18).fork()).join();
    }
    if (message.recordingTime !== undefined) {
      writer.uint32(24).int64(message.recordingTime);
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status);
    }
    for (const v of message.errors) {
      writer.uint32(42).string(v!);
    }
    if (message.insvUploadedCount !== undefined) {
      writer.uint32(48).uint32(message.insvUploadedCount);
    }
    if (message.insvBacklogCount !== undefined) {
      writer.uint32(56).uint32(message.insvBacklogCount);
    }
    for (const v of message.recentImports) {
      InsvUploadStatus.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecorderState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecorderState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = RecorderConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.recordingTime = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.errors.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.insvUploadedCount = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.insvBacklogCount = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.recentImports.push(InsvUploadStatus.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RecorderState {
    return {
      config: isSet(object.config) ? RecorderConfig.fromJSON(object.config) : undefined,
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      recordingTime: isSet(object.recordingTime) ? globalThis.Number(object.recordingTime) : undefined,
      status: isSet(object.status) ? recorderStatusFromJSON(object.status) : 0,
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => globalThis.String(e)) : [],
      insvUploadedCount: isSet(object.insvUploadedCount) ? globalThis.Number(object.insvUploadedCount) : undefined,
      insvBacklogCount: isSet(object.insvBacklogCount) ? globalThis.Number(object.insvBacklogCount) : undefined,
      recentImports: globalThis.Array.isArray(object?.recentImports)
        ? object.recentImports.map((e: any) => InsvUploadStatus.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RecorderState): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = RecorderConfig.toJSON(message.config);
    }
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.recordingTime !== undefined) {
      obj.recordingTime = Math.round(message.recordingTime);
    }
    if (message.status !== 0) {
      obj.status = recorderStatusToJSON(message.status);
    }
    if (message.errors?.length) {
      obj.errors = message.errors;
    }
    if (message.insvUploadedCount !== undefined) {
      obj.insvUploadedCount = Math.round(message.insvUploadedCount);
    }
    if (message.insvBacklogCount !== undefined) {
      obj.insvBacklogCount = Math.round(message.insvBacklogCount);
    }
    if (message.recentImports?.length) {
      obj.recentImports = message.recentImports.map((e) => InsvUploadStatus.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RecorderState>, I>>(base?: I): RecorderState {
    return RecorderState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecorderState>, I>>(object: I): RecorderState {
    const message = createBaseRecorderState();
    message.config = (object.config !== undefined && object.config !== null)
      ? RecorderConfig.fromPartial(object.config)
      : undefined;
    message.startTime = object.startTime ?? undefined;
    message.recordingTime = object.recordingTime ?? undefined;
    message.status = object.status ?? 0;
    message.errors = object.errors?.map((e) => e) || [];
    message.insvUploadedCount = object.insvUploadedCount ?? undefined;
    message.insvBacklogCount = object.insvBacklogCount ?? undefined;
    message.recentImports = object.recentImports?.map((e) => InsvUploadStatus.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUploadItem(): UploadItem {
  return { recordingId: "", progress: 0, error: undefined };
}

export const UploadItem: MessageFns<UploadItem> = {
  encode(message: UploadItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.recordingId !== "") {
      writer.uint32(10).string(message.recordingId);
    }
    if (message.progress !== 0) {
      writer.uint32(16).uint32(message.progress);
    }
    if (message.error !== undefined) {
      writer.uint32(26).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.recordingId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.progress = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadItem {
    return {
      recordingId: isSet(object.recordingId) ? globalThis.String(object.recordingId) : "",
      progress: isSet(object.progress) ? globalThis.Number(object.progress) : 0,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    };
  },

  toJSON(message: UploadItem): unknown {
    const obj: any = {};
    if (message.recordingId !== "") {
      obj.recordingId = message.recordingId;
    }
    if (message.progress !== 0) {
      obj.progress = Math.round(message.progress);
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadItem>, I>>(base?: I): UploadItem {
    return UploadItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadItem>, I>>(object: I): UploadItem {
    const message = createBaseUploadItem();
    message.recordingId = object.recordingId ?? "";
    message.progress = object.progress ?? 0;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseUploadState(): UploadState {
  return { uploads: [] };
}

export const UploadState: MessageFns<UploadState> = {
  encode(message: UploadState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.uploads) {
      UploadItem.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uploads.push(UploadItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadState {
    return {
      uploads: globalThis.Array.isArray(object?.uploads) ? object.uploads.map((e: any) => UploadItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: UploadState): unknown {
    const obj: any = {};
    if (message.uploads?.length) {
      obj.uploads = message.uploads.map((e) => UploadItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadState>, I>>(base?: I): UploadState {
    return UploadState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadState>, I>>(object: I): UploadState {
    const message = createBaseUploadState();
    message.uploads = object.uploads?.map((e) => UploadItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInsvUploadStatus(): InsvUploadStatus {
  return { filename: "", status: "", detail: undefined };
}

export const InsvUploadStatus: MessageFns<InsvUploadStatus> = {
  encode(message: InsvUploadStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filename !== "") {
      writer.uint32(10).string(message.filename);
    }
    if (message.status !== "") {
      writer.uint32(18).string(message.status);
    }
    if (message.detail !== undefined) {
      writer.uint32(26).string(message.detail);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InsvUploadStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInsvUploadStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.detail = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InsvUploadStatus {
    return {
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      detail: isSet(object.detail) ? globalThis.String(object.detail) : undefined,
    };
  },

  toJSON(message: InsvUploadStatus): unknown {
    const obj: any = {};
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.detail !== undefined) {
      obj.detail = message.detail;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InsvUploadStatus>, I>>(base?: I): InsvUploadStatus {
    return InsvUploadStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InsvUploadStatus>, I>>(object: I): InsvUploadStatus {
    const message = createBaseInsvUploadStatus();
    message.filename = object.filename ?? "";
    message.status = object.status ?? "";
    message.detail = object.detail ?? undefined;
    return message;
  },
};

function createBaseReferenceFramePose(): ReferenceFramePose {
  return { x: 0, y: 0, z: 0, i: 0, j: 0, k: 0, w: 0 };
}

export const ReferenceFramePose: MessageFns<ReferenceFramePose> = {
  encode(message: ReferenceFramePose, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(9).double(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(17).double(message.y);
    }
    if (message.z !== 0) {
      writer.uint32(25).double(message.z);
    }
    if (message.i !== 0) {
      writer.uint32(33).double(message.i);
    }
    if (message.j !== 0) {
      writer.uint32(41).double(message.j);
    }
    if (message.k !== 0) {
      writer.uint32(49).double(message.k);
    }
    if (message.w !== 0) {
      writer.uint32(57).double(message.w);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReferenceFramePose {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReferenceFramePose();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.x = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.y = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.z = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.i = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.j = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.k = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.w = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReferenceFramePose {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      z: isSet(object.z) ? globalThis.Number(object.z) : 0,
      i: isSet(object.i) ? globalThis.Number(object.i) : 0,
      j: isSet(object.j) ? globalThis.Number(object.j) : 0,
      k: isSet(object.k) ? globalThis.Number(object.k) : 0,
      w: isSet(object.w) ? globalThis.Number(object.w) : 0,
    };
  },

  toJSON(message: ReferenceFramePose): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.z !== 0) {
      obj.z = message.z;
    }
    if (message.i !== 0) {
      obj.i = message.i;
    }
    if (message.j !== 0) {
      obj.j = message.j;
    }
    if (message.k !== 0) {
      obj.k = message.k;
    }
    if (message.w !== 0) {
      obj.w = message.w;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReferenceFramePose>, I>>(base?: I): ReferenceFramePose {
    return ReferenceFramePose.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReferenceFramePose>, I>>(object: I): ReferenceFramePose {
    const message = createBaseReferenceFramePose();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.z = object.z ?? 0;
    message.i = object.i ?? 0;
    message.j = object.j ?? 0;
    message.k = object.k ?? 0;
    message.w = object.w ?? 0;
    return message;
  },
};

function createBaseReferenceFrame(): ReferenceFrame {
  return { refWorldPose: undefined, refTcpOption: undefined };
}

export const ReferenceFrame: MessageFns<ReferenceFrame> = {
  encode(message: ReferenceFrame, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.refWorldPose !== undefined) {
      ReferenceFramePose.encode(message.refWorldPose, writer.uint32(10).fork()).join();
    }
    if (message.refTcpOption !== undefined) {
      writer.uint32(18).string(message.refTcpOption);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReferenceFrame {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReferenceFrame();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.refWorldPose = ReferenceFramePose.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.refTcpOption = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReferenceFrame {
    return {
      refWorldPose: isSet(object.refWorldPose) ? ReferenceFramePose.fromJSON(object.refWorldPose) : undefined,
      refTcpOption: isSet(object.refTcpOption) ? globalThis.String(object.refTcpOption) : undefined,
    };
  },

  toJSON(message: ReferenceFrame): unknown {
    const obj: any = {};
    if (message.refWorldPose !== undefined) {
      obj.refWorldPose = ReferenceFramePose.toJSON(message.refWorldPose);
    }
    if (message.refTcpOption !== undefined) {
      obj.refTcpOption = message.refTcpOption;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReferenceFrame>, I>>(base?: I): ReferenceFrame {
    return ReferenceFrame.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReferenceFrame>, I>>(object: I): ReferenceFrame {
    const message = createBaseReferenceFrame();
    message.refWorldPose = (object.refWorldPose !== undefined && object.refWorldPose !== null)
      ? ReferenceFramePose.fromPartial(object.refWorldPose)
      : undefined;
    message.refTcpOption = object.refTcpOption ?? undefined;
    return message;
  },
};

function createBaseEquipmentAssignment(): EquipmentAssignment {
  return { equipmentId: "", feed: undefined };
}

export const EquipmentAssignment: MessageFns<EquipmentAssignment> = {
  encode(message: EquipmentAssignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.equipmentId !== "") {
      writer.uint32(10).string(message.equipmentId);
    }
    if (message.feed !== undefined) {
      writer.uint32(18).string(message.feed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EquipmentAssignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEquipmentAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.equipmentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.feed = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EquipmentAssignment {
    return {
      equipmentId: isSet(object.equipmentId) ? globalThis.String(object.equipmentId) : "",
      feed: isSet(object.feed) ? globalThis.String(object.feed) : undefined,
    };
  },

  toJSON(message: EquipmentAssignment): unknown {
    const obj: any = {};
    if (message.equipmentId !== "") {
      obj.equipmentId = message.equipmentId;
    }
    if (message.feed !== undefined) {
      obj.feed = message.feed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EquipmentAssignment>, I>>(base?: I): EquipmentAssignment {
    return EquipmentAssignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EquipmentAssignment>, I>>(object: I): EquipmentAssignment {
    const message = createBaseEquipmentAssignment();
    message.equipmentId = object.equipmentId ?? "";
    message.feed = object.feed ?? undefined;
    return message;
  },
};

function createBaseRecorderConfig(): RecorderConfig {
  return {
    userId: undefined,
    taskId: undefined,
    isSecondary: undefined,
    bots: [],
    sensors: [],
    equipmentKeyAssignments: {},
    tags: [],
    recordingMode: undefined,
    referenceFrame: undefined,
  };
}

export const RecorderConfig: MessageFns<RecorderConfig> = {
  encode(message: RecorderConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== undefined) {
      writer.uint32(10).string(message.userId);
    }
    if (message.taskId !== undefined) {
      writer.uint32(18).string(message.taskId);
    }
    if (message.isSecondary !== undefined) {
      writer.uint32(24).bool(message.isSecondary);
    }
    for (const v of message.bots) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.sensors) {
      SensorConfig.encode(v!, writer.uint32(42).fork()).join();
    }
    Object.entries(message.equipmentKeyAssignments).forEach(([key, value]) => {
      RecorderConfig_EquipmentKeyAssignmentsEntry.encode({ key: key as any, value }, writer.uint32(50).fork()).join();
    });
    for (const v of message.tags) {
      writer.uint32(58).string(v!);
    }
    if (message.recordingMode !== undefined) {
      writer.uint32(64).int32(message.recordingMode);
    }
    if (message.referenceFrame !== undefined) {
      ReferenceFrame.encode(message.referenceFrame, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecorderConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecorderConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isSecondary = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.bots.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sensors.push(SensorConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          const entry6 = RecorderConfig_EquipmentKeyAssignmentsEntry.decode(reader, reader.uint32());
          if (entry6.value !== undefined) {
            message.equipmentKeyAssignments[entry6.key] = entry6.value;
          }
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.recordingMode = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.referenceFrame = ReferenceFrame.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RecorderConfig {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : undefined,
      taskId: isSet(object.taskId) ? globalThis.String(object.taskId) : undefined,
      isSecondary: isSet(object.isSecondary) ? globalThis.Boolean(object.isSecondary) : undefined,
      bots: globalThis.Array.isArray(object?.bots) ? object.bots.map((e: any) => globalThis.String(e)) : [],
      sensors: globalThis.Array.isArray(object?.sensors)
        ? object.sensors.map((e: any) => SensorConfig.fromJSON(e))
        : [],
      equipmentKeyAssignments: isObject(object.equipmentKeyAssignments)
        ? Object.entries(object.equipmentKeyAssignments).reduce<{ [key: string]: EquipmentAssignment }>(
          (acc, [key, value]) => {
            acc[key] = EquipmentAssignment.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      recordingMode: isSet(object.recordingMode) ? recordingModeFromJSON(object.recordingMode) : undefined,
      referenceFrame: isSet(object.referenceFrame) ? ReferenceFrame.fromJSON(object.referenceFrame) : undefined,
    };
  },

  toJSON(message: RecorderConfig): unknown {
    const obj: any = {};
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    if (message.taskId !== undefined) {
      obj.taskId = message.taskId;
    }
    if (message.isSecondary !== undefined) {
      obj.isSecondary = message.isSecondary;
    }
    if (message.bots?.length) {
      obj.bots = message.bots;
    }
    if (message.sensors?.length) {
      obj.sensors = message.sensors.map((e) => SensorConfig.toJSON(e));
    }
    if (message.equipmentKeyAssignments) {
      const entries = Object.entries(message.equipmentKeyAssignments);
      if (entries.length > 0) {
        obj.equipmentKeyAssignments = {};
        entries.forEach(([k, v]) => {
          obj.equipmentKeyAssignments[k] = EquipmentAssignment.toJSON(v);
        });
      }
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.recordingMode !== undefined) {
      obj.recordingMode = recordingModeToJSON(message.recordingMode);
    }
    if (message.referenceFrame !== undefined) {
      obj.referenceFrame = ReferenceFrame.toJSON(message.referenceFrame);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RecorderConfig>, I>>(base?: I): RecorderConfig {
    return RecorderConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecorderConfig>, I>>(object: I): RecorderConfig {
    const message = createBaseRecorderConfig();
    message.userId = object.userId ?? undefined;
    message.taskId = object.taskId ?? undefined;
    message.isSecondary = object.isSecondary ?? undefined;
    message.bots = object.bots?.map((e) => e) || [];
    message.sensors = object.sensors?.map((e) => SensorConfig.fromPartial(e)) || [];
    message.equipmentKeyAssignments = Object.entries(object.equipmentKeyAssignments ?? {}).reduce<
      { [key: string]: EquipmentAssignment }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = EquipmentAssignment.fromPartial(value);
      }
      return acc;
    }, {});
    message.tags = object.tags?.map((e) => e) || [];
    message.recordingMode = object.recordingMode ?? undefined;
    message.referenceFrame = (object.referenceFrame !== undefined && object.referenceFrame !== null)
      ? ReferenceFrame.fromPartial(object.referenceFrame)
      : undefined;
    return message;
  },
};

function createBaseRecorderConfig_EquipmentKeyAssignmentsEntry(): RecorderConfig_EquipmentKeyAssignmentsEntry {
  return { key: "", value: undefined };
}

export const RecorderConfig_EquipmentKeyAssignmentsEntry: MessageFns<RecorderConfig_EquipmentKeyAssignmentsEntry> = {
  encode(
    message: RecorderConfig_EquipmentKeyAssignmentsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      EquipmentAssignment.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecorderConfig_EquipmentKeyAssignmentsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecorderConfig_EquipmentKeyAssignmentsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = EquipmentAssignment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RecorderConfig_EquipmentKeyAssignmentsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? EquipmentAssignment.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: RecorderConfig_EquipmentKeyAssignmentsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = EquipmentAssignment.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RecorderConfig_EquipmentKeyAssignmentsEntry>, I>>(
    base?: I,
  ): RecorderConfig_EquipmentKeyAssignmentsEntry {
    return RecorderConfig_EquipmentKeyAssignmentsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecorderConfig_EquipmentKeyAssignmentsEntry>, I>>(
    object: I,
  ): RecorderConfig_EquipmentKeyAssignmentsEntry {
    const message = createBaseRecorderConfig_EquipmentKeyAssignmentsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? EquipmentAssignment.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseConfigureRecordingRequest(): ConfigureRecordingRequest {
  return { config: undefined };
}

export const ConfigureRecordingRequest: MessageFns<ConfigureRecordingRequest> = {
  encode(message: ConfigureRecordingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      RecorderConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigureRecordingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigureRecordingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = RecorderConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigureRecordingRequest {
    return { config: isSet(object.config) ? RecorderConfig.fromJSON(object.config) : undefined };
  },

  toJSON(message: ConfigureRecordingRequest): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = RecorderConfig.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigureRecordingRequest>, I>>(base?: I): ConfigureRecordingRequest {
    return ConfigureRecordingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigureRecordingRequest>, I>>(object: I): ConfigureRecordingRequest {
    const message = createBaseConfigureRecordingRequest();
    message.config = (object.config !== undefined && object.config !== null)
      ? RecorderConfig.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseToggleBotPayload(): ToggleBotPayload {
  return { botId: "", isEnabled: false };
}

export const ToggleBotPayload: MessageFns<ToggleBotPayload> = {
  encode(message: ToggleBotPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.botId !== "") {
      writer.uint32(10).string(message.botId);
    }
    if (message.isEnabled !== false) {
      writer.uint32(16).bool(message.isEnabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToggleBotPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleBotPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.botId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleBotPayload {
    return {
      botId: isSet(object.botId) ? globalThis.String(object.botId) : "",
      isEnabled: isSet(object.isEnabled) ? globalThis.Boolean(object.isEnabled) : false,
    };
  },

  toJSON(message: ToggleBotPayload): unknown {
    const obj: any = {};
    if (message.botId !== "") {
      obj.botId = message.botId;
    }
    if (message.isEnabled !== false) {
      obj.isEnabled = message.isEnabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleBotPayload>, I>>(base?: I): ToggleBotPayload {
    return ToggleBotPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleBotPayload>, I>>(object: I): ToggleBotPayload {
    const message = createBaseToggleBotPayload();
    message.botId = object.botId ?? "";
    message.isEnabled = object.isEnabled ?? false;
    return message;
  },
};

function createBaseStartRecordingRequest(): StartRecordingRequest {
  return { startTime: undefined, equipmentKeyAssignments: {} };
}

export const StartRecordingRequest: MessageFns<StartRecordingRequest> = {
  encode(message: StartRecordingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(10).fork()).join();
    }
    Object.entries(message.equipmentKeyAssignments).forEach(([key, value]) => {
      StartRecordingRequest_EquipmentKeyAssignmentsEntry.encode({ key: key as any, value }, writer.uint32(18).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartRecordingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartRecordingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = StartRecordingRequest_EquipmentKeyAssignmentsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.equipmentKeyAssignments[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartRecordingRequest {
    return {
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      equipmentKeyAssignments: isObject(object.equipmentKeyAssignments)
        ? Object.entries(object.equipmentKeyAssignments).reduce<{ [key: string]: EquipmentAssignment }>(
          (acc, [key, value]) => {
            acc[key] = EquipmentAssignment.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: StartRecordingRequest): unknown {
    const obj: any = {};
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.equipmentKeyAssignments) {
      const entries = Object.entries(message.equipmentKeyAssignments);
      if (entries.length > 0) {
        obj.equipmentKeyAssignments = {};
        entries.forEach(([k, v]) => {
          obj.equipmentKeyAssignments[k] = EquipmentAssignment.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartRecordingRequest>, I>>(base?: I): StartRecordingRequest {
    return StartRecordingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartRecordingRequest>, I>>(object: I): StartRecordingRequest {
    const message = createBaseStartRecordingRequest();
    message.startTime = object.startTime ?? undefined;
    message.equipmentKeyAssignments = Object.entries(object.equipmentKeyAssignments ?? {}).reduce<
      { [key: string]: EquipmentAssignment }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = EquipmentAssignment.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseStartRecordingRequest_EquipmentKeyAssignmentsEntry(): StartRecordingRequest_EquipmentKeyAssignmentsEntry {
  return { key: "", value: undefined };
}

export const StartRecordingRequest_EquipmentKeyAssignmentsEntry: MessageFns<
  StartRecordingRequest_EquipmentKeyAssignmentsEntry
> = {
  encode(
    message: StartRecordingRequest_EquipmentKeyAssignmentsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      EquipmentAssignment.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartRecordingRequest_EquipmentKeyAssignmentsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartRecordingRequest_EquipmentKeyAssignmentsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = EquipmentAssignment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartRecordingRequest_EquipmentKeyAssignmentsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? EquipmentAssignment.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StartRecordingRequest_EquipmentKeyAssignmentsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = EquipmentAssignment.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartRecordingRequest_EquipmentKeyAssignmentsEntry>, I>>(
    base?: I,
  ): StartRecordingRequest_EquipmentKeyAssignmentsEntry {
    return StartRecordingRequest_EquipmentKeyAssignmentsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartRecordingRequest_EquipmentKeyAssignmentsEntry>, I>>(
    object: I,
  ): StartRecordingRequest_EquipmentKeyAssignmentsEntry {
    const message = createBaseStartRecordingRequest_EquipmentKeyAssignmentsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? EquipmentAssignment.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStepDetailsEntry(): StepDetailsEntry {
  return {
    stepId: "",
    stepKind: "",
    startOffsetSec: undefined,
    endOffsetSec: undefined,
    selfTimeSec: undefined,
    parentStepIds: [],
    stepArgs: undefined,
    stepVariables: undefined,
  };
}

export const StepDetailsEntry: MessageFns<StepDetailsEntry> = {
  encode(message: StepDetailsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stepId !== "") {
      writer.uint32(10).string(message.stepId);
    }
    if (message.stepKind !== "") {
      writer.uint32(18).string(message.stepKind);
    }
    if (message.startOffsetSec !== undefined) {
      writer.uint32(29).float(message.startOffsetSec);
    }
    if (message.endOffsetSec !== undefined) {
      writer.uint32(37).float(message.endOffsetSec);
    }
    if (message.selfTimeSec !== undefined) {
      writer.uint32(45).float(message.selfTimeSec);
    }
    for (const v of message.parentStepIds) {
      writer.uint32(50).string(v!);
    }
    if (message.stepArgs !== undefined) {
      writer.uint32(58).string(message.stepArgs);
    }
    if (message.stepVariables !== undefined) {
      writer.uint32(66).string(message.stepVariables);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepDetailsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepDetailsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.stepId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stepKind = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.startOffsetSec = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.endOffsetSec = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.selfTimeSec = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentStepIds.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.stepArgs = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.stepVariables = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepDetailsEntry {
    return {
      stepId: isSet(object.stepId) ? globalThis.String(object.stepId) : "",
      stepKind: isSet(object.stepKind) ? globalThis.String(object.stepKind) : "",
      startOffsetSec: isSet(object.startOffsetSec) ? globalThis.Number(object.startOffsetSec) : undefined,
      endOffsetSec: isSet(object.endOffsetSec) ? globalThis.Number(object.endOffsetSec) : undefined,
      selfTimeSec: isSet(object.selfTimeSec) ? globalThis.Number(object.selfTimeSec) : undefined,
      parentStepIds: globalThis.Array.isArray(object?.parentStepIds)
        ? object.parentStepIds.map((e: any) => globalThis.String(e))
        : [],
      stepArgs: isSet(object.stepArgs) ? globalThis.String(object.stepArgs) : undefined,
      stepVariables: isSet(object.stepVariables) ? globalThis.String(object.stepVariables) : undefined,
    };
  },

  toJSON(message: StepDetailsEntry): unknown {
    const obj: any = {};
    if (message.stepId !== "") {
      obj.stepId = message.stepId;
    }
    if (message.stepKind !== "") {
      obj.stepKind = message.stepKind;
    }
    if (message.startOffsetSec !== undefined) {
      obj.startOffsetSec = message.startOffsetSec;
    }
    if (message.endOffsetSec !== undefined) {
      obj.endOffsetSec = message.endOffsetSec;
    }
    if (message.selfTimeSec !== undefined) {
      obj.selfTimeSec = message.selfTimeSec;
    }
    if (message.parentStepIds?.length) {
      obj.parentStepIds = message.parentStepIds;
    }
    if (message.stepArgs !== undefined) {
      obj.stepArgs = message.stepArgs;
    }
    if (message.stepVariables !== undefined) {
      obj.stepVariables = message.stepVariables;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StepDetailsEntry>, I>>(base?: I): StepDetailsEntry {
    return StepDetailsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StepDetailsEntry>, I>>(object: I): StepDetailsEntry {
    const message = createBaseStepDetailsEntry();
    message.stepId = object.stepId ?? "";
    message.stepKind = object.stepKind ?? "";
    message.startOffsetSec = object.startOffsetSec ?? undefined;
    message.endOffsetSec = object.endOffsetSec ?? undefined;
    message.selfTimeSec = object.selfTimeSec ?? undefined;
    message.parentStepIds = object.parentStepIds?.map((e) => e) || [];
    message.stepArgs = object.stepArgs ?? undefined;
    message.stepVariables = object.stepVariables ?? undefined;
    return message;
  },
};

function createBaseStepDetails(): StepDetails {
  return { entries: [] };
}

export const StepDetails: MessageFns<StepDetails> = {
  encode(message: StepDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entries) {
      StepDetailsEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StepDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStepDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entries.push(StepDetailsEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StepDetails {
    return {
      entries: globalThis.Array.isArray(object?.entries)
        ? object.entries.map((e: any) => StepDetailsEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StepDetails): unknown {
    const obj: any = {};
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => StepDetailsEntry.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StepDetails>, I>>(base?: I): StepDetails {
    return StepDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StepDetails>, I>>(object: I): StepDetails {
    const message = createBaseStepDetails();
    message.entries = object.entries?.map((e) => StepDetailsEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStopRecordingRequest(): StopRecordingRequest {
  return { delete: false, tags: [], stepDetails: undefined };
}

export const StopRecordingRequest: MessageFns<StopRecordingRequest> = {
  encode(message: StopRecordingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.delete !== false) {
      writer.uint32(8).bool(message.delete);
    }
    for (const v of message.tags) {
      writer.uint32(18).string(v!);
    }
    if (message.stepDetails !== undefined) {
      StepDetails.encode(message.stepDetails, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopRecordingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopRecordingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.delete = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.stepDetails = StepDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopRecordingRequest {
    return {
      delete: isSet(object.delete) ? globalThis.Boolean(object.delete) : false,
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      stepDetails: isSet(object.stepDetails) ? StepDetails.fromJSON(object.stepDetails) : undefined,
    };
  },

  toJSON(message: StopRecordingRequest): unknown {
    const obj: any = {};
    if (message.delete !== false) {
      obj.delete = message.delete;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.stepDetails !== undefined) {
      obj.stepDetails = StepDetails.toJSON(message.stepDetails);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopRecordingRequest>, I>>(base?: I): StopRecordingRequest {
    return StopRecordingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopRecordingRequest>, I>>(object: I): StopRecordingRequest {
    const message = createBaseStopRecordingRequest();
    message.delete = object.delete ?? false;
    message.tags = object.tags?.map((e) => e) || [];
    message.stepDetails = (object.stepDetails !== undefined && object.stepDetails !== null)
      ? StepDetails.fromPartial(object.stepDetails)
      : undefined;
    return message;
  },
};

function createBaseStopRecordingResponse(): StopRecordingResponse {
  return { startTimestamp: undefined, endTimestamp: undefined, status: 0 };
}

export const StopRecordingResponse: MessageFns<StopRecordingResponse> = {
  encode(message: StopRecordingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startTimestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.startTimestamp), writer.uint32(10).fork()).join();
    }
    if (message.endTimestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.endTimestamp), writer.uint32(18).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopRecordingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopRecordingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startTimestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endTimestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopRecordingResponse {
    return {
      startTimestamp: isSet(object.startTimestamp) ? fromJsonTimestamp(object.startTimestamp) : undefined,
      endTimestamp: isSet(object.endTimestamp) ? fromJsonTimestamp(object.endTimestamp) : undefined,
      status: isSet(object.status) ? recorderStatusFromJSON(object.status) : 0,
    };
  },

  toJSON(message: StopRecordingResponse): unknown {
    const obj: any = {};
    if (message.startTimestamp !== undefined) {
      obj.startTimestamp = message.startTimestamp.toISOString();
    }
    if (message.endTimestamp !== undefined) {
      obj.endTimestamp = message.endTimestamp.toISOString();
    }
    if (message.status !== 0) {
      obj.status = recorderStatusToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopRecordingResponse>, I>>(base?: I): StopRecordingResponse {
    return StopRecordingResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopRecordingResponse>, I>>(object: I): StopRecordingResponse {
    const message = createBaseStopRecordingResponse();
    message.startTimestamp = object.startTimestamp ?? undefined;
    message.endTimestamp = object.endTimestamp ?? undefined;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseSaveRecordingRequest(): SaveRecordingRequest {
  return { recordingId: undefined, startTimestamp: undefined, endTimestamp: undefined, wait: undefined };
}

export const SaveRecordingRequest: MessageFns<SaveRecordingRequest> = {
  encode(message: SaveRecordingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.recordingId !== undefined) {
      writer.uint32(10).string(message.recordingId);
    }
    if (message.startTimestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.startTimestamp), writer.uint32(18).fork()).join();
    }
    if (message.endTimestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.endTimestamp), writer.uint32(26).fork()).join();
    }
    if (message.wait !== undefined) {
      writer.uint32(32).bool(message.wait);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveRecordingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSaveRecordingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.recordingId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.startTimestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.endTimestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.wait = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SaveRecordingRequest {
    return {
      recordingId: isSet(object.recordingId) ? globalThis.String(object.recordingId) : undefined,
      startTimestamp: isSet(object.startTimestamp) ? fromJsonTimestamp(object.startTimestamp) : undefined,
      endTimestamp: isSet(object.endTimestamp) ? fromJsonTimestamp(object.endTimestamp) : undefined,
      wait: isSet(object.wait) ? globalThis.Boolean(object.wait) : undefined,
    };
  },

  toJSON(message: SaveRecordingRequest): unknown {
    const obj: any = {};
    if (message.recordingId !== undefined) {
      obj.recordingId = message.recordingId;
    }
    if (message.startTimestamp !== undefined) {
      obj.startTimestamp = message.startTimestamp.toISOString();
    }
    if (message.endTimestamp !== undefined) {
      obj.endTimestamp = message.endTimestamp.toISOString();
    }
    if (message.wait !== undefined) {
      obj.wait = message.wait;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SaveRecordingRequest>, I>>(base?: I): SaveRecordingRequest {
    return SaveRecordingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SaveRecordingRequest>, I>>(object: I): SaveRecordingRequest {
    const message = createBaseSaveRecordingRequest();
    message.recordingId = object.recordingId ?? undefined;
    message.startTimestamp = object.startTimestamp ?? undefined;
    message.endTimestamp = object.endTimestamp ?? undefined;
    message.wait = object.wait ?? undefined;
    return message;
  },
};

function createBaseSaveRecordingResponse(): SaveRecordingResponse {
  return { uploadId: "", error: undefined };
}

export const SaveRecordingResponse: MessageFns<SaveRecordingResponse> = {
  encode(message: SaveRecordingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uploadId !== "") {
      writer.uint32(10).string(message.uploadId);
    }
    if (message.error !== undefined) {
      writer.uint32(18).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveRecordingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSaveRecordingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uploadId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SaveRecordingResponse {
    return {
      uploadId: isSet(object.uploadId) ? globalThis.String(object.uploadId) : "",
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    };
  },

  toJSON(message: SaveRecordingResponse): unknown {
    const obj: any = {};
    if (message.uploadId !== "") {
      obj.uploadId = message.uploadId;
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SaveRecordingResponse>, I>>(base?: I): SaveRecordingResponse {
    return SaveRecordingResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SaveRecordingResponse>, I>>(object: I): SaveRecordingResponse {
    const message = createBaseSaveRecordingResponse();
    message.uploadId = object.uploadId ?? "";
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseEchoBotResponse(): EchoBotResponse {
  return { success: false, errors: [] };
}

export const EchoBotResponse: MessageFns<EchoBotResponse> = {
  encode(message: EchoBotResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    for (const v of message.errors) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EchoBotResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEchoBotResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.errors.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EchoBotResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: EchoBotResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.errors?.length) {
      obj.errors = message.errors;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EchoBotResponse>, I>>(base?: I): EchoBotResponse {
    return EchoBotResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EchoBotResponse>, I>>(object: I): EchoBotResponse {
    const message = createBaseEchoBotResponse();
    message.success = object.success ?? false;
    message.errors = object.errors?.map((e) => e) || [];
    return message;
  },
};

function createBaseAddTagRequest(): AddTagRequest {
  return { tags: [] };
}

export const AddTagRequest: MessageFns<AddTagRequest> = {
  encode(message: AddTagRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tags) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddTagRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddTagRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddTagRequest {
    return { tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: AddTagRequest): unknown {
    const obj: any = {};
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddTagRequest>, I>>(base?: I): AddTagRequest {
    return AddTagRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddTagRequest>, I>>(object: I): AddTagRequest {
    const message = createBaseAddTagRequest();
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

/** @language: python */
export interface EchoBotService {
  GetRecorderState(request: Empty): Promise<RecorderState>;
  ConfigureRecording(request: ConfigureRecordingRequest): Promise<RecorderState>;
  ToggleBot(request: ToggleBotPayload): Promise<RecorderState>;
  StartRecording(request: StartRecordingRequest): Promise<RecorderState>;
  StopRecording(request: StopRecordingRequest): Promise<StopRecordingResponse>;
  SaveRecording(request: SaveRecordingRequest): Promise<SaveRecordingResponse>;
  GetUploadState(request: Empty): Promise<UploadState>;
  AddTag(request: AddTagRequest): Promise<EchoBotResponse>;
  ClearHardwareConfigCache(request: Empty): Promise<EchoBotResponse>;
}

export const EchoBotServiceServiceName = "echobot.EchoBotService";
export class EchoBotServiceClientImpl implements EchoBotService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || EchoBotServiceServiceName;
    this.rpc = rpc;
    this.GetRecorderState = this.GetRecorderState.bind(this);
    this.ConfigureRecording = this.ConfigureRecording.bind(this);
    this.ToggleBot = this.ToggleBot.bind(this);
    this.StartRecording = this.StartRecording.bind(this);
    this.StopRecording = this.StopRecording.bind(this);
    this.SaveRecording = this.SaveRecording.bind(this);
    this.GetUploadState = this.GetUploadState.bind(this);
    this.AddTag = this.AddTag.bind(this);
    this.ClearHardwareConfigCache = this.ClearHardwareConfigCache.bind(this);
  }
  GetRecorderState(request: Empty): Promise<RecorderState> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetRecorderState", data);
    return promise.then((data) => RecorderState.decode(new BinaryReader(data)));
  }

  ConfigureRecording(request: ConfigureRecordingRequest): Promise<RecorderState> {
    const data = ConfigureRecordingRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ConfigureRecording", data);
    return promise.then((data) => RecorderState.decode(new BinaryReader(data)));
  }

  ToggleBot(request: ToggleBotPayload): Promise<RecorderState> {
    const data = ToggleBotPayload.encode(request).finish();
    const promise = this.rpc.request(this.service, "ToggleBot", data);
    return promise.then((data) => RecorderState.decode(new BinaryReader(data)));
  }

  StartRecording(request: StartRecordingRequest): Promise<RecorderState> {
    const data = StartRecordingRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "StartRecording", data);
    return promise.then((data) => RecorderState.decode(new BinaryReader(data)));
  }

  StopRecording(request: StopRecordingRequest): Promise<StopRecordingResponse> {
    const data = StopRecordingRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "StopRecording", data);
    return promise.then((data) => StopRecordingResponse.decode(new BinaryReader(data)));
  }

  SaveRecording(request: SaveRecordingRequest): Promise<SaveRecordingResponse> {
    const data = SaveRecordingRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SaveRecording", data);
    return promise.then((data) => SaveRecordingResponse.decode(new BinaryReader(data)));
  }

  GetUploadState(request: Empty): Promise<UploadState> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetUploadState", data);
    return promise.then((data) => UploadState.decode(new BinaryReader(data)));
  }

  AddTag(request: AddTagRequest): Promise<EchoBotResponse> {
    const data = AddTagRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "AddTag", data);
    return promise.then((data) => EchoBotResponse.decode(new BinaryReader(data)));
  }

  ClearHardwareConfigCache(request: Empty): Promise<EchoBotResponse> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "ClearHardwareConfigCache", data);
    return promise.then((data) => EchoBotResponse.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/echo_bot_service.proto",
    "package": "echobot",
    "dependency": ["google/protobuf/timestamp.proto"],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "Empty",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SensorConfig",
      "field": [{
        "name": "id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "id",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "equipment_name",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "equipmentName",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "equipment_key",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "equipmentKey",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "sensor_type",
        "number": 4,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "sensorType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "data_type",
        "number": 5,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "dataType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "filename",
        "number": 6,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "filename",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "is_secondary",
        "number": 7,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "isSecondary",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "metadata",
        "number": 8,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "metadata",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RecorderState",
      "field": [{
        "name": "config",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".echobot.RecorderConfig",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "config",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "start_time",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".google.protobuf.Timestamp",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "startTime",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "recording_time",
        "number": 3,
        "label": 1,
        "type": 3,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "recordingTime",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "status",
        "number": 4,
        "label": 1,
        "type": 14,
        "typeName": ".echobot.RecorderStatus",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "status",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "errors",
        "number": 5,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "errors",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "insv_uploaded_count",
        "number": 6,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "insvUploadedCount",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "insv_backlog_count",
        "number": 7,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "insvBacklogCount",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "recent_imports",
        "number": 8,
        "label": 3,
        "type": 11,
        "typeName": ".echobot.InsvUploadStatus",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "recentImports",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_recording_time", "options": undefined }, {
        "name": "_insv_uploaded_count",
        "options": undefined,
      }, { "name": "_insv_backlog_count", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "UploadItem",
      "field": [{
        "name": "recording_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "recordingId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "progress",
        "number": 2,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "progress",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "UploadState",
      "field": [{
        "name": "uploads",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".echobot.UploadItem",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "uploads",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "InsvUploadStatus",
      "field": [{
        "name": "filename",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "filename",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "status",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "status",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "detail",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "detail",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_detail", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ReferenceFramePose",
      "field": [{
        "name": "x",
        "number": 1,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y",
        "number": 2,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "z",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "z",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "i",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "i",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "j",
        "number": 5,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "j",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "k",
        "number": 6,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "k",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "w",
        "number": 7,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "w",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ReferenceFrame",
      "field": [{
        "name": "ref_world_pose",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".echobot.ReferenceFramePose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "refWorldPose",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ref_tcp_option",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "refTcpOption",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_ref_tcp_option", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "EquipmentAssignment",
      "field": [{
        "name": "equipment_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "equipmentId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "feed",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "feed",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_feed", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RecorderConfig",
      "field": [{
        "name": "user_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "userId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "task_id",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "taskId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "is_secondary",
        "number": 3,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "isSecondary",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "bots",
        "number": 4,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "bots",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "sensors",
        "number": 5,
        "label": 3,
        "type": 11,
        "typeName": ".echobot.SensorConfig",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "sensors",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "equipment_key_assignments",
        "number": 6,
        "label": 3,
        "type": 11,
        "typeName": ".echobot.RecorderConfig.EquipmentKeyAssignmentsEntry",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "equipmentKeyAssignments",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "tags",
        "number": 7,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "tags",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "recording_mode",
        "number": 8,
        "label": 1,
        "type": 14,
        "typeName": ".echobot.RecordingMode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "recordingMode",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "reference_frame",
        "number": 9,
        "label": 1,
        "type": 11,
        "typeName": ".echobot.ReferenceFrame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 4,
        "jsonName": "referenceFrame",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [{
        "name": "EquipmentKeyAssignmentsEntry",
        "field": [{
          "name": "key",
          "number": 1,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "key",
          "options": undefined,
          "proto3Optional": false,
        }, {
          "name": "value",
          "number": 2,
          "label": 1,
          "type": 11,
          "typeName": ".echobot.EquipmentAssignment",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "value",
          "options": undefined,
          "proto3Optional": false,
        }],
        "extension": [],
        "nestedType": [],
        "enumType": [],
        "extensionRange": [],
        "oneofDecl": [],
        "options": {
          "messageSetWireFormat": false,
          "noStandardDescriptorAccessor": false,
          "deprecated": false,
          "mapEntry": true,
          "uninterpretedOption": [],
        },
        "reservedRange": [],
        "reservedName": [],
      }],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_user_id", "options": undefined },
        { "name": "_task_id", "options": undefined },
        { "name": "_is_secondary", "options": undefined },
        { "name": "_recording_mode", "options": undefined },
        { "name": "_reference_frame", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ConfigureRecordingRequest",
      "field": [{
        "name": "config",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".echobot.RecorderConfig",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "config",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ToggleBotPayload",
      "field": [{
        "name": "bot_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "botId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "is_enabled",
        "number": 2,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "isEnabled",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StartRecordingRequest",
      "field": [{
        "name": "start_time",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".google.protobuf.Timestamp",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "startTime",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "equipment_key_assignments",
        "number": 2,
        "label": 3,
        "type": 11,
        "typeName": ".echobot.StartRecordingRequest.EquipmentKeyAssignmentsEntry",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "equipmentKeyAssignments",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [{
        "name": "EquipmentKeyAssignmentsEntry",
        "field": [{
          "name": "key",
          "number": 1,
          "label": 1,
          "type": 9,
          "typeName": "",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "key",
          "options": undefined,
          "proto3Optional": false,
        }, {
          "name": "value",
          "number": 2,
          "label": 1,
          "type": 11,
          "typeName": ".echobot.EquipmentAssignment",
          "extendee": "",
          "defaultValue": "",
          "oneofIndex": 0,
          "jsonName": "value",
          "options": undefined,
          "proto3Optional": false,
        }],
        "extension": [],
        "nestedType": [],
        "enumType": [],
        "extensionRange": [],
        "oneofDecl": [],
        "options": {
          "messageSetWireFormat": false,
          "noStandardDescriptorAccessor": false,
          "deprecated": false,
          "mapEntry": true,
          "uninterpretedOption": [],
        },
        "reservedRange": [],
        "reservedName": [],
      }],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StepDetailsEntry",
      "field": [{
        "name": "step_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "stepId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "step_kind",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "stepKind",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "start_offset_sec",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "startOffsetSec",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "end_offset_sec",
        "number": 4,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "endOffsetSec",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "self_time_sec",
        "number": 5,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "selfTimeSec",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "parent_step_ids",
        "number": 6,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "parentStepIds",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "step_args",
        "number": 7,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "stepArgs",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "step_variables",
        "number": 8,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 4,
        "jsonName": "stepVariables",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_start_offset_sec", "options": undefined },
        { "name": "_end_offset_sec", "options": undefined },
        { "name": "_self_time_sec", "options": undefined },
        { "name": "_step_args", "options": undefined },
        { "name": "_step_variables", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StepDetails",
      "field": [{
        "name": "entries",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".echobot.StepDetailsEntry",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "entries",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StopRecordingRequest",
      "field": [{
        "name": "delete",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "delete",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "tags",
        "number": 2,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "tags",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "step_details",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".echobot.StepDetails",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "stepDetails",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_step_details", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StopRecordingResponse",
      "field": [{
        "name": "start_timestamp",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".google.protobuf.Timestamp",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "startTimestamp",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "end_timestamp",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".google.protobuf.Timestamp",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "endTimestamp",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "status",
        "number": 3,
        "label": 1,
        "type": 14,
        "typeName": ".echobot.RecorderStatus",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "status",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SaveRecordingRequest",
      "field": [{
        "name": "recording_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "recordingId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "start_timestamp",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".google.protobuf.Timestamp",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "startTimestamp",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "end_timestamp",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".google.protobuf.Timestamp",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "endTimestamp",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "wait",
        "number": 4,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "wait",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_recording_id", "options": undefined }, { "name": "_wait", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SaveRecordingResponse",
      "field": [{
        "name": "upload_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "uploadId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_error", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "EchoBotResponse",
      "field": [{
        "name": "success",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "success",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "errors",
        "number": 2,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "errors",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "AddTagRequest",
      "field": [{
        "name": "tags",
        "number": 1,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "tags",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "RecorderStatus",
      "value": [
        { "name": "NOT_RECORDING", "number": 0, "options": undefined },
        { "name": "RECORDING", "number": 1, "options": undefined },
        { "name": "ERROR", "number": 2, "options": undefined },
        { "name": "COMPLETE", "number": 3, "options": undefined },
        { "name": "INITIALIZING", "number": 4, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RecordingMode",
      "value": [{ "name": "RECORDING_MODE_STANDARD", "number": 0, "options": undefined }, {
        "name": "RECORDING_MODE_DEMONSTRATION",
        "number": 1,
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "EchoBotService",
      "method": [{
        "name": "GetRecorderState",
        "inputType": ".echobot.Empty",
        "outputType": ".echobot.RecorderState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ConfigureRecording",
        "inputType": ".echobot.ConfigureRecordingRequest",
        "outputType": ".echobot.RecorderState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ToggleBot",
        "inputType": ".echobot.ToggleBotPayload",
        "outputType": ".echobot.RecorderState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "StartRecording",
        "inputType": ".echobot.StartRecordingRequest",
        "outputType": ".echobot.RecorderState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "StopRecording",
        "inputType": ".echobot.StopRecordingRequest",
        "outputType": ".echobot.StopRecordingResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SaveRecording",
        "inputType": ".echobot.SaveRecordingRequest",
        "outputType": ".echobot.SaveRecordingResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetUploadState",
        "inputType": ".echobot.Empty",
        "outputType": ".echobot.UploadState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "AddTag",
        "inputType": ".echobot.AddTagRequest",
        "outputType": ".echobot.EchoBotResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ClearHardwareConfigCache",
        "inputType": ".echobot.Empty",
        "outputType": ".echobot.EchoBotResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/messenger/proto/echobot",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [6, 0],
        "span": [7, 0, 17, 1],
        "leadingComments": " @language: python\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 7],
        "span": [37, 2, 22],
        "leadingComments": "",
        "trailingComments": " JSON string\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2, 2, 5],
        "span": [52, 2, 42],
        "leadingComments":
          ' .insv handheld-upload metrics (in-memory, reset on echo-bot restart):\n count uploaded since start, and count still pending on disk. `optional`\n so callers can tell "echo-bot\'s RPC handler threw before computing these"\n (absent) apart from "computed and genuinely zero" — a recorder-level\n error (status=ERROR from a bad recording) still computes these\n independently, so status alone can\'t be used as a presence proxy.\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 2, 2, 7],
        "span": [57, 2, 47],
        "leadingComments":
          " Recent .insv import outcomes (most-recent-last), so the upload modal can\n show per-file Uploaded / Duplicate / Failed instead of only a counter.\n In-memory, bounded, reset on echo-bot restart.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5],
        "span": [73, 0, 82, 1],
        "leadingComments":
          " Per-file status of a handheld .insv upload, keyed by the inbox filename so\n the upload modal can correlate the file it sent with what echo-bot did.\n status is one of: processing | uploaded | duplicate | failed.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5, 2, 2],
        "span": [81, 2, 29],
        "leadingComments":
          ' Human-readable reason, set only for terminal failures whose cause the\n operator can act on (e.g. "no calibration for IAFNA2511FX9U4"). The UI\n appends it to the status label; absent means "no extra detail", not\n "unknown". Kept as free text rather than new `status` values so the\n frontend\'s processing|uploaded|duplicate|failed bucketing stays exact.\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6],
        "span": [90, 0, 98, 1],
        "leadingComments": " Standard Bots quaternion pose (x,y,z position + i,j,k,w orientation).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 7],
        "span": [103, 0, 106, 1],
        "leadingComments":
          ' Optional "follow reference" anchor for a demonstration recording: the\n reference\'s world pose at record time, plus the tcpOption it was saved in\n (used by sphere-trim to choose wrist vs gripper-tip distance).\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 8],
        "span": [110, 0, 116, 1],
        "leadingComments":
          " Equipment bound to a hardware key. For dual-lens cameras (Insta360) the\n optional feed selects which lens the recording captures.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 8, 2, 0],
        "span": [112, 2, 26],
        "leadingComments": " Equipment ID from bot(s).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 8, 2, 1],
        "span": [115, 2, 27],
        "leadingComments":
          ' Lens selection for dual-lens cameras: "front" | "back". Unset for\n single-lens devices; unrecognized values are ignored with a warning.\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13, 2, 2],
        "span": [147, 2, 148, 8],
        "leadingComments": "",
        "trailingComments": " we will always fill, but if it is 0 and not optional - proto omits it\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13, 2, 4],
        "span": [150, 2, 35],
        "leadingComments": "",
        "trailingComments": " Time spent in step excluding substeps\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13, 2, 5],
        "span": [151, 2, 38],
        "leadingComments": "",
        "trailingComments": " IDs of parent steps in the hierarchy\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13, 2, 6],
        "span": [152, 2, 32],
        "leadingComments": "",
        "trailingComments": " JSON stringified step arguments/configuration\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 13, 2, 7],
        "span": [153, 2, 37],
        "leadingComments": "",
        "trailingComments": " JSON stringified step output variables\n",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".echobot.RecorderStatus": RecorderStatus,
    ".echobot.RecordingMode": RecordingMode,
    ".echobot.Empty": Empty,
    ".echobot.SensorConfig": SensorConfig,
    ".echobot.RecorderState": RecorderState,
    ".echobot.UploadItem": UploadItem,
    ".echobot.UploadState": UploadState,
    ".echobot.InsvUploadStatus": InsvUploadStatus,
    ".echobot.ReferenceFramePose": ReferenceFramePose,
    ".echobot.ReferenceFrame": ReferenceFrame,
    ".echobot.EquipmentAssignment": EquipmentAssignment,
    ".echobot.RecorderConfig": RecorderConfig,
    ".echobot.RecorderConfig.EquipmentKeyAssignmentsEntry": RecorderConfig_EquipmentKeyAssignmentsEntry,
    ".echobot.ConfigureRecordingRequest": ConfigureRecordingRequest,
    ".echobot.ToggleBotPayload": ToggleBotPayload,
    ".echobot.StartRecordingRequest": StartRecordingRequest,
    ".echobot.StartRecordingRequest.EquipmentKeyAssignmentsEntry": StartRecordingRequest_EquipmentKeyAssignmentsEntry,
    ".echobot.StepDetailsEntry": StepDetailsEntry,
    ".echobot.StepDetails": StepDetails,
    ".echobot.StopRecordingRequest": StopRecordingRequest,
    ".echobot.StopRecordingResponse": StopRecordingResponse,
    ".echobot.SaveRecordingRequest": SaveRecordingRequest,
    ".echobot.SaveRecordingResponse": SaveRecordingResponse,
    ".echobot.EchoBotResponse": EchoBotResponse,
    ".echobot.AddTagRequest": AddTagRequest,
    ".echobot.EchoBotService": EchoBotServiceClientImpl,
  },
  dependencies: [protoMetadata1],
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
